module.exports = __webpack_public_path__ + "slide1-welcomeoctopus.a5be93078062e71b0bb8d31c6107cddb.hashedasset.svg";